import useId from '../utils/useId';
import * as React from 'react';
export const openrouterSvg = React.forwardRef(function openrouterSvgInner(
  props,
  ref,
) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_openrouter__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M32 0H0v32h32V0Z',
        fill: '#090F11',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M23.208 6.75a5.507 5.507 0 0 1 5.512 5.502 5.507 5.507 0 0 1-5.512 5.503l5.467 5.457c.694.694.203 1.879-.78 1.879h-15.71C7.113 25.091 3 20.985 3 15.921c0-5.065 4.113-9.171 9.185-9.171h11.023Zm-11.022 3.668a5.507 5.507 0 0 0-5.512 5.503 5.507 5.507 0 0 0 5.511 5.502 5.507 5.507 0 0 0 5.512-5.502 5.507 5.507 0 0 0-5.511-5.503Z',
        fill: '#BFFF00',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_openrouter__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
    ),
  );
});
openrouterSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var openrouter = {
  category: 'brand',
  colorable: false,
  name: 'openrouter',
  svg: openrouterSvg,
};
